<div class="post-table-container">
  <p-table
    #abpPostTable
    [value]="allPostsData"
    [loading]="postLoading"
    sortMode="single"
    [(selection)]="selectedRows"
    [globalFilterFields]="['type', 'status', 'showcaseCreativeDetails.callToAction', 'startDate', 'endDate']"
    dataKey="type"
    scrollable="true"
    [scrollHeight]="'calc(100vh - 407px)'"
    rowExpandMode="single"
    responsive="true"
    [paginator]="true"
    [lazy]="true"
    [rows]="pageSize"
    (onLazyLoad)="lazyLoadData($event)"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} "
    [showCurrentPageReport]="true"
    [totalRecords]="totalPostsCount"
  >
    <ng-template pTemplate="caption">
      <div class="flex-search-bar">
        <div class="search-bar-buttons">
          <!--<div class="acct-search">
            <span class="p-input-icon-right">
              <i class="pi pi-search"></i>
              <span class="p-inputgroup">
                <input
                  class="input"
                  pInputText
                  type="text"
                  placeholder="Search by Store Code..."
                  [(ngModel)]="keyword"
                  (input)="abpPostTable.filterGlobal($event.target.value, 'contains')"
                />
                <button
                  pButton
                  type="button"
                  icon="fa fa-filter"
                  class="filter-button"
                  [ngStyle]="chipsArray.length > 0 && { color: SYSTEM_COLORS.$systemGreen }"
                  (click)="op.toggle($event)"
                ></button>
                <p-overlayPanel #op>
                  <ng-template pTemplate>
                    <div class="search-filter">
                      <app-table-filter [data]="filterData" (filterData)="onChipsRefresh($event)"></app-table-filter>
                    </div>
                  </ng-template>
                </p-overlayPanel>
              </span>
            </span>
          </div>
        -->
          <div class="button-div-flex" [pTooltip]="createPostTooltip()">
            <button
              pButton
              label="CREATE SHOWCASE"
              class="p-button-primary"
              iconPos="left"
              icon="pi pi-plus-circle"
              (click)="openPostCreate()"
              [disabled]="accountIsNotLeaf || !checkAddPerms || appleMapsDisabled"
            ></button>
          </div>
        </div>
      </div>
      <div class="chips-bar">
        <p-chip *ngFor="let chipText of chipsArray" [label]="chipText"></p-chip>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr *ngIf="allPostsData">
        <th *ngIf="false" class="p-selectable-row">SELECT</th>
        <th class="smaller-columns" pSortableColumn="type">ID <p-sortIcon field="type"></p-sortIcon></th>
        <th>PHOTO</th>
        <th>STATUS</th>
        <th>HEADING</th>
        <th>ACTION</th>
        <th>START DATE</th>
        <th>END DATE</th>
        <th>LOCATIONS</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
      <tr>
        <td *ngIf="false" class="p-selectable-row">
          <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
        </td>
        <td class="smaller-columns">
          {{ getSequentialNumber(rowIndex) }}
        </td>
        <td>
          <img
            [src]="rowData.showcaseCreativeDetails?.photo?.s3Url || rowData.internalURL || rowData.sourceURL || errorImg"
            (error)="rowData.showcaseCreativeDetails.photo.s3Url = errorImg || (rowData.sourceURL = errorImg && (rowData.internalURL = errorImg))"
            class="table-photo"
            *ngIf="rowData.showcaseCreativeDetails?.photo?.s3Url || rowData.internalURL || rowData.sourceURL"
          />
          <span *ngIf="!rowData.showcaseCreativeDetails?.photo?.s3Url && !rowData.internalURL && !rowData.sourceURL">-</span>
        </td>
        <td>
          <div class="status-cell">
            <div class="activity-button" [ngClass]="getRowStatus(rowData) | activityStatus">
              {{ getRowStatus(rowData) | getStatus }}
            </div>
            <button
              *ngIf="canSuspendShowcase(rowData)"
              type="button"
              class="suspend-showcase-btn"
              [disabled]="isDeactivating(rowData)"
              (click)="openSuspendConfirm(rowData)"
            >
              {{ isDeactivating(rowData) ? 'Suspending...' : 'Deactivate' }}
            </button>
          </div>
        </td>
        <td>
          {{ getHeadlineText(rowData) }}
        </td>
        <td>{{ getCallToAction(rowData) }}</td>
        <td>{{ rowData.startDate ? (rowData.startDate | date: 'MM/dd/yyyy') : '-' }}</td>
        <td>{{ rowData.endDate ? (rowData.endDate | date: 'MM/dd/yyyy') : '-' }}</td>
        <td class="table-locations">
          <span class="table-locations-links" (click)="openLocations(rowData)"
            >{{ getLocationsText(rowData) }}</span
          >
        </td>
        <!-- <td class="table-activity">
          <div class="edit_date">
            {{
            rowData.created_at
            ? (rowData.created_at | date: 'MM/dd/yyyy')
            : rowData.scheduleTime
            ? rowData.scheduleTime?.strftime('%m/%d/%Y %H:%M')
            : rowData.createTime ? rowData.createTime?.strftime('%m/%d/%Y') :
            rowData._lastUpdatedAt?.strftime('%m/%d/%Y') || '-'
            }}
            <span *ngIf="(rowData?.status === 'PENDING_REVIEW' || rowData?._status === activityStatus.SCHEDULED) && checkEditPerms" class="edit_date__enable" (click)="editPost(rowData)"><i
                class="pi pi-pencil"></i>
            </span>

            <span *ngIf="rowData?.status !== 'PENDING_REVIEW' && rowData?._status !== activityStatus.SCHEDULED" class="edit_date__disable">
              <i class="pi pi-pencil"></i>
            </span>
          </div >
        </td> -->
        <!-- <td class="table-actions">
          <ul class="table-actions-list">
            <li (click)="editPost(rowData)" [class.disabled]="(rowData?.status === 'REJECTED' || rowData?._status === 'AR') || !checkEditPerms">
              <i class="pi pi-pencil"></i> Edit
            </li>
            <li class="disabled" [pTooltip]="tooltipText"><i class="pi pi-map"></i> Duplicate</li>

            <li *ngIf="false"
            [ngClass]="{ disabled: rowData?.status === 'PUBLISHED' || rowData?._status === activityStatus.PUBLISHED }"
              (click)="unpublishPost(rowData)"
            >
              <i class="pi pi-ban"></i> Unpublish
            </li>
            <li class="disabled" [pTooltip]="tooltipText"><i class="pi pi-ban"></i> Unpublish</li>

            <li [class]="deleteBtnClass(rowData)" (click)="openPostDelete(rowData)" [class.disable_post__delete]="!checkDeletePerms">
              <i class="pi pi-trash"></i> Delete
            </li>
          </ul>
        </td> -->
      </tr>
    </ng-template>
  </p-table>

  <ng-template #loading>
    <p-progressSpinner></p-progressSpinner>
  </ng-template>
</div>
